import { z } from "zod";

export const LibrarySchema = z.object({
  id: z.string(),
  chat_id: z.string().nullish(),
  media_id: z.string().nullish(),
  thumbnail_id: z.string().nullish(),
  organization_id: z.string().nullish(),
  name: z.string().nullish(),
  description: z.string().nullish(),
  tags: z.string().nullish(),
  media_url: z.string(),
  media_type: z.string(),
  media_source: z.string(),
  media_metadata: z.any().nullish(),
  thumbnail_metadata: z.any().nullish(),
  thumbnail_url: z.string().nullish(),
  deleted_at: z.string().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type Library = z.infer<typeof LibrarySchema>;
